import { t } from 'i18next';
import { useContext, useMemo } from 'react';

import StatusTabs, { StatusTab } from '~components/Tabs/StatusTabs';

import ApproveChargesPageContext from '../ApproveChargesPageContext';
import { CHARGES_GRAIN_TABS, ChargesGrainTab } from '../approveChargesTabs';

const grainTabLabelKeys = {
  [ChargesGrainTab.HOURLY_JOBS]: 'approvals.approve_charges.grain_tabs.hourly_jobs',
  [ChargesGrainTab.LOADS]: 'approvals.approve_charges.grain_tabs.loads',
} satisfies Record<ChargesGrainTab, string>;

export default function ChargesGrainTabs() {
  const { grainTab, setGrainTab } = useContext(ApproveChargesPageContext);

  const tabs = useMemo<StatusTab<ChargesGrainTab>[]>(
    () =>
      CHARGES_GRAIN_TABS.map((tab) => ({
        label: t(grainTabLabelKeys[tab]),
        value: tab,
      })),
    [],
  );

  return <StatusTabs onChange={setGrainTab} selectedTab={grainTab} tabs={tabs} />;
}
